import React from 'react';
import styled from 'styled-components';
import aiImg from '../assets/images/aiconsultant.png';

const PageContainer = styled.div`
  padding-top: 80px;
  max-width: 900px;
  margin: 0 auto;
`;
const HeroImage = styled.div`
  width: 100%;
  height: 320px;
  background: url(${aiImg}) center center/cover no-repeat;
  border-radius: 12px;
  margin-bottom: 2.5rem;
  box-shadow: 0 10px 30px rgba(0,0,0,0.07);
`;
const Title = styled.h1`
  font-size: 2.3rem;
  font-weight: 700;
  margin: 2rem 0 2.5rem 0;
  color: #222;
  text-align: center;
`;
const Section = styled.section`
  margin-bottom: 2.5rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 2rem 2.5rem;
`;
const SectionTitle = styled.h2`
  font-size: 1.4rem;
  color: var(--primary);
  margin-bottom: 1rem;
  font-weight: 600;
`;
const Paragraph = styled.p`
  color: #333;
  line-height: 1.7;
  margin-bottom: 1.2rem;
`;
const ServiceList = styled.ul`
  margin-top: 0.5rem;
  margin-bottom: 1.2rem;
  list-style: disc inside;
  padding-left: 1.2rem;
`;
const ServiceItem = styled.li`
  color: #333;
  font-weight: 500;
  margin-bottom: 0.5rem;
`;
const TagList = styled.ul`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1rem;
  padding: 0;
  list-style: none;
`;
const Tag = styled.li`
  background: var(--primary);
  color: #fff;
  border-radius: 16px;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 0.4rem 1.1rem;
  margin-bottom: 0.5rem;
`;

const UseCaseAIDocumentation = () => (
  <PageContainer>
    <HeroImage />
    <Title>AI Strategy for Pharma Documentation & Compliance</Title>
    <Section>
      <SectionTitle>The Situation</SectionTitle>
      <Paragraph>
        Many pharmaceutical companies still rely on manual, paper-based processes for quality assurance, regulatory compliance, and batch release. This results in long cycle times for QA, human error in documentation, and difficulties ensuring compliance with GxP, FDA, EMA, and other regulations. Poor traceability between production and documentation systems increases both time and regulatory risk, especially during audits or recalls.
      </Paragraph>
    </Section>
    <Section>
      <SectionTitle>How Platform0 Would Help</SectionTitle>
      <Paragraph>
        Platform0 would define a clear AI integration roadmap designed for life sciences environments:
      </Paragraph>
      <ServiceList>
        <ServiceItem>Use NLP to digitize and structure unstructured regulatory documents</ServiceItem>
        <ServiceItem>Design an auditable AI engine to classify, validate, and flag compliance gaps in real time</ServiceItem>
        <ServiceItem>Build a modular architecture to integrate LIMS, ERP, and quality systems</ServiceItem>
        <ServiceItem>Ensure all solutions are built with GxP-ready frameworks for validation, traceability, and audit trails</ServiceItem>
      </ServiceList>
    </Section>
    <Section>
      <SectionTitle>The Expected Outcomes</SectionTitle>
      <ServiceList>
        <ServiceItem>Cut document handling time by 50% or more</ServiceItem>
        <ServiceItem>Accelerate batch release by weeks</ServiceItem>
        <ServiceItem>Increase internal audit readiness</ServiceItem>
        <ServiceItem>Reduce regulatory risk while freeing QA teams for critical oversight</ServiceItem>
      </ServiceList>
    </Section>
    <Section>
      <SectionTitle>Relevant Platform0 Services</SectionTitle>
      <TagList>
        <Tag>AI Consultancy</Tag>
        <Tag>Architecture as a Service</Tag>
        <Tag>Digital Transformation</Tag>
      </TagList>
    </Section>
  </PageContainer>
);

export default UseCaseAIDocumentation;
